/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  OTELMetricsPayload,
  OTELMetricsPayload$Outbound,
  OTELMetricsPayload$outboundSchema,
} from "../components/otelmetricspayload.js";

export type HooksNumberMetricsSecurityOption1 = {
  deviceAgentTokenHeaderAuthorization: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberMetricsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberMetricsSecurity = {
  option1?: HooksNumberMetricsSecurityOption1 | undefined;
  option2?: HooksNumberMetricsSecurityOption2 | undefined;
};

export type HooksNumberMetricsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  otelMetricsPayload: OTELMetricsPayload;
};

/** @internal */
export type HooksNumberMetricsSecurityOption1$Outbound = {
  device_agent_token_header_Authorization: string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberMetricsSecurityOption1$outboundSchema: z.ZodMiniType<
  HooksNumberMetricsSecurityOption1$Outbound,
  HooksNumberMetricsSecurityOption1
> = z.pipe(
  z.object({
    deviceAgentTokenHeaderAuthorization: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      deviceAgentTokenHeaderAuthorization:
        "device_agent_token_header_Authorization",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberMetricsSecurityOption1ToJSON(
  hooksNumberMetricsSecurityOption1: HooksNumberMetricsSecurityOption1,
): string {
  return JSON.stringify(
    HooksNumberMetricsSecurityOption1$outboundSchema.parse(
      hooksNumberMetricsSecurityOption1,
    ),
  );
}

/** @internal */
export type HooksNumberMetricsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberMetricsSecurityOption2$outboundSchema: z.ZodMiniType<
  HooksNumberMetricsSecurityOption2$Outbound,
  HooksNumberMetricsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberMetricsSecurityOption2ToJSON(
  hooksNumberMetricsSecurityOption2: HooksNumberMetricsSecurityOption2,
): string {
  return JSON.stringify(
    HooksNumberMetricsSecurityOption2$outboundSchema.parse(
      hooksNumberMetricsSecurityOption2,
    ),
  );
}

/** @internal */
export type HooksNumberMetricsSecurity$Outbound = {
  Option1?: HooksNumberMetricsSecurityOption1$Outbound | undefined;
  Option2?: HooksNumberMetricsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const HooksNumberMetricsSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberMetricsSecurity$Outbound,
  HooksNumberMetricsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => HooksNumberMetricsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => HooksNumberMetricsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function hooksNumberMetricsSecurityToJSON(
  hooksNumberMetricsSecurity: HooksNumberMetricsSecurity,
): string {
  return JSON.stringify(
    HooksNumberMetricsSecurity$outboundSchema.parse(hooksNumberMetricsSecurity),
  );
}

/** @internal */
export type HooksNumberMetricsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  OTELMetricsPayload: OTELMetricsPayload$Outbound;
};

/** @internal */
export const HooksNumberMetricsRequest$outboundSchema: z.ZodMiniType<
  HooksNumberMetricsRequest$Outbound,
  HooksNumberMetricsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    otelMetricsPayload: OTELMetricsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      otelMetricsPayload: "OTELMetricsPayload",
    });
  }),
);

export function hooksNumberMetricsRequestToJSON(
  hooksNumberMetricsRequest: HooksNumberMetricsRequest,
): string {
  return JSON.stringify(
    HooksNumberMetricsRequest$outboundSchema.parse(hooksNumberMetricsRequest),
  );
}
